import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import * as Yup from "yup";
import "../../../../Styles/Ht.css";
import { config } from "../../../CommonUtilities/CommonUrl/CommonUrls";
import {  CommonAxiosGet,CommonAxiosPost} from "../../../CommonUtilities/CommonAxios/CommonAxios";
import { ErrorMessage, Field, FormikProvider,useFormik, FieldArray} from "formik";
import { CommonPageHeading } from "../../../CommonUtilities/CommonHeading/CommonPageHeading";
import Sweetalert from "../../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts";
import { Addres_Msg,AddresRemarks, ERROR_MSG,} from "../../../CommonUtilities/Validations/RegularExpAndVar";
import { VscDiffAdded } from "react-icons/vsc";
import { BiTrash } from "react-icons/bi";
import { IoIosArrowDown } from "react-icons/io";

export default function ObjectionForm() {
  const [showData, setData] = useState([]);
  const [examCenterData, setExamCenterData] = useState([]);
  const [showhstatus, sethstatus] = useState();
  const [postData, setPostData] = useState([]);

  const getDataFunction = async (candidateId) => {
    let Url = config.url.DSC_DEPT_URL + "print-application/candidate?candidateId=" +
      candidateId;

    try {
      const res = await CommonAxiosGet(Url);
      if (res?.data?.status === true) {
        setExamCenterData(
          res?.data.examcenterdetails_status === true
            ? res.data.examcenterdetails
            : []
        );
        setPostData(res?.data?.htDetails_status ? res?.data?.htDetails : []);
        setData(
          res?.data?.candidatereg_status ? res?.data?.candidatereg[0] : {}
        );
        sethstatus(res?.data?.htDetails_status);
      } else {
        sethstatus(false);
        setPostData([]);
      }
    } catch (error) {
      console.error("Error in getDataFunction", error);
      setPostData([]);
    }
  };
  const [showExamDate, setExamDate] = useState([]);
  const[mediumId,setMediumId]=useState();
  function renderExams() {
    // let Url = config.url.DSC_Read_URL + "exams-for-objections";
    let Url = config.url.DSC_Read_URL + "tet-exams-for-objections";
    CommonAxiosGet(Url).then((res) => {
      if (res?.data?.status === true) {
        setExamDate(res?.data?.data);
        setMediumId(res?.data?.data[0]?.medium_id);
      } else {
        setExamDate([]);
      }
    });
  }
  useEffect(() => {
    renderExams();
  }, []);
  const [showQuestions, setQuestions] = useState([]);

  // function renderQuestionOptions(index, post_id) {
  //   try {
  //     const parsedJson = showExamDate?.filter(
  //       (val) => val?.post_id === parseInt(post_id)
  //     );
  //     const data = JSON.parse(parsedJson[index]?.ques_ans_json || "[]");
  //     setQuestions((prev) => {
  //       const newArr = [...prev];
  //       newArr[index] = data;
  //       return newArr;
  //     });
  //   } catch (e) {
  //     console.error("Failed to parse ques_ans_json at index:", index, e);
  //     setQuestions((prev) => {
  //       const newArr = [...prev];
  //       newArr[index] = [];
  //       return newArr;
  //     });
  //   }
  // }

  function renderQuestionOptions(index, post_id) {
  try {
    const parsedJson = showExamDate?.filter(
      (val) => val?.post_id === post_id  
    );
    const data = JSON.parse(parsedJson[0]?.ques_ans_json || "[]");
    setQuestions((prev) => {
      const newArr = [...prev];
      newArr[index] = data; 
      return newArr;
    });
  } catch (e) {
    console.error("Failed to parse ques_ans_json at index:", index, e);
    setQuestions((prev) => {
      const newArr = [...prev];
      newArr[index] = [];
      return newArr;
    });
  }
}

  const candidateFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      candidateId: "",
      tetObjectionList: [
        {
          questionId: "",
          objId: "",
          candidateAns: "",
          paperId: "",
          remarks: "",
          ansKey:"",
          // mediumId :mediumId
        },
      ],
    },
    validationSchema: Yup.object().shape({
      tetObjectionList: Yup.array().of(
        Yup.object().shape({
          objId: Yup.string().required(ERROR_MSG).nullable(),
          paperId: Yup.string().required(ERROR_MSG).nullable(),
          questionId: Yup.string().required(ERROR_MSG).nullable(),
          remarks: Yup.string().required(ERROR_MSG).nullable().matches(AddresRemarks, Addres_Msg),
          // candidateAns: Yup.string().when("objId", {
          //   is: (objId) => objId == 4,
          //   then: Yup.string().required(ERROR_MSG).nullable(),
          //   oterwise: Yup.string().nullable(),
          // }),
candidateAns: Yup.string().when("objId", {
  is: (objId) => objId === 4,
  then: Yup.string()
    .required(ERROR_MSG)
    .test(
      "candidate-ans-not-key",
      "Selected answer must be different from answer key",
      (value, context) => {
        const { ansKey } = context.parent;
        if (!value || !ansKey) return true;
        return value !== ansKey;
      }
    ),
  otherwise: Yup.string().nullable(),
}),

 })),}),
    onSubmit: (values) => {
      // let url = config.url.DSC_URL + "candidate-objections-entry"; 
      const payload = {
    ...values,
    tetObjectionList: values.tetObjectionList.map(item => ({
      ...item,
      mediumId: mediumId  
    }))
  };
  let url = config.url.DSC_URL + "tet-candidate-objections-entry";
  CommonAxiosPost(url, payload).then((res) => {
    if (res?.data?.status === true) {
      Sweetalert("Successfully Submitted", "success")
        .then(() => window.location.reload());
    } else {
      Sweetalert(res?.data?.sdesc || "", "error");
    }
  });
    },
  });
    return (
        <div className="p-0 mt-4" >
            <CommonPageHeading heading='Objections Entry' />
            <FormikProvider value={candidateFormik}>
                <Form className="form-section" onSubmit={candidateFormik.handleSubmit} onChange={candidateFormik.handleChange}>
                    <div className="personal-head">
                        <span>AP TET-2026 Objection(s) Entry</span></div>
                    <div className="personal-row mb-2">
                        <div className="table-responsive px-3 mb-3" >
                            <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-0"
                                style={{ borderCollapse: 'collapse', }}>
                                <thead>
                                    <tr> <td>S.No.</td>
                                        <td> <Form.Label className="input-lable mb-2">Paper,Exam Dt:Shift,Language</Form.Label></td>
                                        <td> <Form.Label className="input-lable mb-2">Question Id</Form.Label></td>
                                        <td><Form.Label className="input-lable mb-2">Answer in Key</Form.Label></td>
                                        <td><Form.Label className="input-lable mb-2">Objection Type</Form.Label></td>
                                        <td><Form.Label className="input-lable mb-2">Candidate Answer</Form.Label></td>
                                        <td><Form.Label className="input-lable mb-2">Explanation/Any Reference /Remarks</Form.Label></td>
                                        <td>Action</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <FieldArray name="tetObjectionList">
                                        {({ form, remove, replace }) => {
                                            return (
                                                <>  {form.values.tetObjectionList?.map((experienceDetails, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}.</td>
                                                            <td>
                                                                <div className="input-div position-relative">
                                                                    <Form.Group >
                                                                        <Field as="select"
                                                                            className="input-field form-control"
                                                                            name={`tetObjectionList[${index}].paperId`}
                                                                            onChange={(e) => {
                                                                                let post_id = e.target.value;
                                                                                renderQuestionOptions(index, post_id)
                                                                                candidateFormik.setFieldValue(`tetObjectionList[${index}].objId`, "")
                                                                                candidateFormik.setFieldValue(`tetObjectionList[${index}].candidateAns`, "")
                                                                                candidateFormik.setFieldValue(`tetObjectionList[${index}].remarks`, "")
                                                                                candidateFormik.setFieldValue(`tetObjectionList[${index}].questionId`, "")
                                                                            }}
                                                                        >   <option value="">Select</option>
                                                                            {showExamDate?.map((val) => { return (<option value={val?.post_id}>{val?.post_name},{val?.exam_date_char}:{val?.exam_time},{val?.medium}</option>) })}
                                                                        </Field>
                                                                        <ErrorMessage name={`tetObjectionList[${index}].paperId`} component="div" className="text-error" />
                                                                    </Form.Group>
                                                                    <IoIosArrowDown className="dropdown-icon" />
                                                                </div>
                                                            </td>
                                                            <td> <div className="input-div position-relative">
                                                                    <Form.Group>
                                                                        <Field as="select" className="input-field form-control"
                                                                            name={`tetObjectionList[${index}].questionId`}
                                                                            onChange={(e) => {
                                                                                let ques_id = e.target.value
                                                                                let data_ques = showQuestions[index]?.filter((val) => val?.question_id === ques_id)[0]
                                                                                candidateFormik?.setFieldValue(`tetObjectionList[${index}].ansKey`, data_ques?.preliminary_key)
                                                                            }}
                                                                        >
                                                                            <option value="">Select</option>
                                                                            {showQuestions[index]?.map((ite, j) => (
                                                                                <option key={j} value={ite?.question_id}>
                                                                                    {ite?.question_id}
                                                                                </option>
                                                                            ))}
                                                                        </Field>
                                                                        <ErrorMessage
                                                                            name={`tetObjectionList[${index}].questionId`}
                                                                            component="div"
                                                                            className="text-error" />
                                                                    </Form.Group>
                                                                    <IoIosArrowDown className="dropdown-icon" />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <Form.Group>
                                                                    <div className=''>{candidateFormik?.values?.tetObjectionList[index].ansKey || '-'}</div>
                                                                </Form.Group>
                                                            </td>
                                                            <td>
                                                                <div className="input-div position-relative">
                                                                    <Form.Group >
                                                                        <Field as="select"
                                                                            className="input-field form-control"
                                                                            name={`tetObjectionList[${index}].objId`}>
                                                                            <option value="">-- Select Issue Type --</option>
                                                                            <option value="1">Incorrect / ambiguous question</option>
                                                                            <option value="2">All options incorrect</option>
                                                                            <option value="3">Multiple correct answers</option>
                                                                            <option value="4">Incorrect answer key</option>
                                                                            <option value="5">Translation error</option>
                                                                            <option value="6">Out of Syllabus</option>
                                                                            <option value="7">Any other</option>
                                                                        </Field>
                                                                        <ErrorMessage
                                                                            name={`tetObjectionList[${index}].objId`}
                                                                            component="div"
                                                                            className="text-error"
                                                                        />
                                                                    </Form.Group>
                                                                    <IoIosArrowDown className="dropdown-icon" />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                {candidateFormik?.values?.tetObjectionList[index]?.objId == 4 &&
                                                                    <div className="input-div position-relative">
                                                                        <Form.Group >
                                                                            <Field as="select"
                                                                                className="input-field form-control"
                                                                                name={`tetObjectionList[${index}].candidateAns`}>
                                                                                <option value="">Select</option>
                                                                                <option value="1">1</option>
                                                                                <option value="2">2</option>
                                                                                <option value="3">3</option>
                                                                                <option value="4">4</option>

                                                                            </Field>
                                                                            <ErrorMessage
                                                                                name={`tetObjectionList[${index}].candidateAns`}
                                                                                component="div"
                                                                                className="text-error"
                                                                            />
                                                                        </Form.Group>
                                                                    </div>}
                                                            </td>
                                                            <td>
                                                                <Form.Group>
                                                                    <Field
                                                                        as="textarea"
                                                                        name={`tetObjectionList[${index}].remarks`}
                                                                        className="input-field form-control"
                                                                        cols={30}
                                                                        rows={1}
                                                                    />
                                                                    <ErrorMessage
                                                                        name={`tetObjectionList[${index}].remarks`}
                                                                        component="div"
                                                                        className="text-error"
                                                                    />
                                                                </Form.Group>
                                                            </td>
                                                            <td className='text-end'>
                                                                <button type="button" className="button-titile btn btn-sm btn-danger mb-2"
                                                                    onClick={() => {
                                                                        if (index === 0) {
                                                                            replace(index, {
                                                                                questionId: "",
                                                                                objId: "",
                                                                                candidateAns: "",
                                                                                paperId: "",
                                                                                remarks: ""
                                                                            });
                                                                        } else {
                                                                            remove(index)
                                                                        }

                                                                    }}>
                                                                    <BiTrash style={{ fontSize: "20px" }}></BiTrash></button></td>
                                                        </tr>))} </>
                                            );
                                        }}
                                    </FieldArray>
                                </tbody>
                                <tfoot>
                                    <tr><td colSpan={8} className='text-end' >
                                            <FieldArray name="tetObjectionList">
                                                {(formikFieldArray) => (
                                                    <button type="button" className="button-titile btn btn-sm btn-success mb-2 btn-end"
                                                        onClick={() => formikFieldArray.push({
                                                            questionId: "",
                                                            objId: "",
                                                            candidateAns: "",
                                                            paperId: "",
                                                            remarks: ""
                                                        })}
                                                    ><VscDiffAdded style={{ fontSize: "20px" }}></VscDiffAdded></button>
                                                )}
                                            </FieldArray>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <div className='float-end mt-2'>
                        <Button variant="success" type="submit" className="submit-btn btn-success" >
                            Submit
                        </Button>
                    </div>


                </Form>
            </FormikProvider>
        </div>
        )
}
